/**
 * Call blast_radius.run_forward for one infrastructure element (persist scores).
 */

import { callHandlerSubhandler } from '../core';

export const TRIAGE_EXTENSION = 'arbitiumtriage';
export const BLAST_RADIUS_HANDLER = 'blast_radius';

export interface RunForwardResult {
  success: boolean;
  output?: Record<string, unknown>;
  raw: Record<string, unknown>;
}

/** Qualify infra element id as infrastructure_elements/{uuid} when needed. */
export function infraNodeId(elementId: string): string {
  const id = String(elementId || '').trim();
  if (!id) return '';
  if (id.includes('/')) return id;
  return `infrastructure_elements/${id}`;
}

/**
 * Recompute EBR (and persist blast_radius_scores) for one infra element.
 */
export async function runBlastRadiusForward(
  elementId: string,
  payload: Record<string, unknown> = {}
): Promise<RunForwardResult> {
  const start = infraNodeId(elementId);
  if (!start) throw new Error('element_id is required');
  const raw = await callHandlerSubhandler(
    TRIAGE_EXTENSION,
    BLAST_RADIUS_HANDLER,
    'run_forward',
    {
      start,
      persist: true,
      refresh_cache: true,
      ...payload,
    }
  );
  const output =
    raw.output && typeof raw.output === 'object'
      ? (raw.output as Record<string, unknown>)
      : undefined;
  return {
    success: raw.success !== false,
    output,
    raw: raw as Record<string, unknown>,
  };
}
